import React, { useCallback } from "react";

import { Link } from "@fluentui/react-components";
import { UnauthenticatedPage } from "./UnauthenticatedPage";
import { observer } from "mobx-react";
import { useNavigate } from "react-router";

const TorusRequiredPageBase = () => {
    const navigate = useNavigate();

    const onclick = useCallback(() => {
        navigate("/login");
    }, [navigate]);

    return (
        <UnauthenticatedPage
            content={
                <div>
                    <p>
                        A Torus account is requred to access this app.{" "}
                        <Link href="#" onClick={onclick}>
                            Click here to sign in using your Torus account
                        </Link>
                    </p>
                </div>
            }
        />
    );
};

export const TorusRequiredPage = observer(TorusRequiredPageBase);
